import React from "react";
import { Grid, Typography } from "@material-ui/core";
import SigninForm from "../components/forms/accounts/Signin";

export default () => (
  <Grid container justify="center">
    <Grid item xs={12}>
      <Grid container justify="center">
        <Typography variant="h3" color="secondary">
          Iniciar sesion
        </Typography>
      </Grid>
    </Grid>
    <SigninForm />
  </Grid>
);
